export enum WebhookEventType {
  PaymentSucceeded = 'PAYMENT_SUCCEEDED',
  PaymentFailed = 'PAYMENT_FAILED',
  PaymentRefunded = 'PAYMENT_REFUNDED',
  OrderSubmissionStarted = 'ORDER_SUBMISSION_STARTED',
  OrderSubmissionSucceeded = 'ORDER_SUBMISSION_SUCCEEDED',
  OrderPlaced = 'ORDER_PLACED',
  OrderFailed = 'ORDER_FAILED',
  OrderCancelFailed = 'ORDER_CANCEL_FAILED',
  OrderCancelStarted = 'ORDER_CANCEL_STARTED',
  OrderCancelRequested = 'ORDER_CANCEL_REQUESTED',
  OrderCancelSucceeded = 'ORDER_CANCEL_SUCCEEDED',
  TrackingObtained = 'TRACKING_OBTAINED',
  RefundCreated = 'REFUND_CREATED',
  ReturnRequested = 'RETURN_REQUESTED',
  ReturnApproved = 'RETURN_APPROVED',
  ReturnClosed = 'RETURN_CLOSED',
  ReturnDeclined = 'RETURN_DECLINED',
  ReturnCancelled = 'RETURN_CANCELLED',
  ProductUpdated = 'PRODUCT_UPDATED',
  ProductDeleted = 'PRODUCT_DELETED',
}
